import React from 'react';
import ReactDOM from 'react-dom';
import Main from './components/Main';
import Footer from './components/Footer';
import 'antd/dist/reset.css';
import './App.css';

const videoFileMP4 = require('./assets/video/videoCar.mp4');
const videoFileWebM = require('./assets/video/videoCar.webm');

const App: React.FC = () => {
  return (
    <div id="wrapper">
      <video id="bg-video" className="video-background" autoPlay loop muted playsInline>
        <source src={videoFileMP4} type="video/mp4" />
        <source src={videoFileWebM} type="video/webm" />
        Your browser does not support the video tag.
      </video>
      <Main />
      <Footer />
    </div>
  );
};

export default App;

ReactDOM.render(<App />, document.getElementById('root'));
